type FormOption = {
  id: string;
  name: string;
};

type Category = {
  id: string;
  name: string;
  categoriesList: SubCategory[];
};

type SubCategory = Omit<Category, 'categoriesList'> & { forms: FormOption[] };

export type Forms = Array<{
  type: 'INDIVIDUAL' | 'ENTERPRISE';
  representativeForms: FormOption[];
  categories: Category[];
}>;
export enum FormType {
  INDIVIDUAL = 'INDIVIDUAL',
  ENTERPRISE = 'ENTERPRISE',
}
